import React, { useContext, useState } from "react";
import SectionPagination from "../../../sections/common/section-pagination";
import TableLoader from "../../../../../common/tableLoader";
import GetProfileImage from "../../../../../common/getProfileImage";
import Toast from "../../../../../common/toast";
import AssignJobConfirmation from "./assign-job-trusted-worker-employee-confirmation";
import Spinner from "../../../../../common/spinner";
import { useSelector } from "react-redux";
import { JobDetailsContext } from "../job-detail1";

function SectionTrustedWorkerEmployeeList({
  isLoading,
  applicantsListData,
  currentPage,
  setCurrentPage,
  totalPages,
  fetchTrustedWorkerEmployeeList,
  // activeTab,
  isSameInstitutionJob,
  isAdminRole,
  // applyTrustedCompanyJobToEmployee,
  selectedEmployee,
  jobDetailsInfo
}) {
  const { role_type } = useSelector((state) => state.menu);
  const [buttonType, setButtonType] = useState("assign");
  const [selectedTrustedWorkerEmployee, setSelectedTrustedWorkerEmployee] =
    useState();

  const StarRating = ({ rating }) => {
    const stars = [];
    console.log("rating----------", rating);
    for (let i = 0; i < 5; i++) {
      if (rating >= i + 1) {
        stars.push(
          <i key={i} className="fas fa-star" style={{ color: "#128c5e" }} />
        );
      } else if (rating >= i + 0.5) {
        stars.push(
          <i
            key={i + 0.5}
            className="fas fa-star-half-alt"
            style={{ color: "#128c5e" }}
          />
        );
      } else {
        stars.push(
          <i key={i} className="far fa-star" style={{ color: "lightgrey" }} />
        );
      }
    }

    return <span>{stars}</span>;
  };

  const assignJobToApplicantConfirmation = (item, type) => {
    setSelectedTrustedWorkerEmployee(item);
    setButtonType(type);
    const ConfirmationBackDrop = document.getElementById(
      "modalBackdropAssignJob"
    );

    const ConfirmationPopupModal = document.getElementById("assign_job_popup");
    if (ConfirmationPopupModal) {
      ConfirmationBackDrop?.classList.add("modal-backdrop", "show");
      ConfirmationBackDrop?.classList.add("show");
      ConfirmationPopupModal?.classList.add("show");
      ConfirmationPopupModal.style.display = "block";
    }
  };

  return (
    <>
      <div className="twm-jobs-list-wrap">
        <ul>
          {!isLoading ? (
            applicantsListData?.length > 0 ? (
              applicantsListData?.map((item) => (
                <li key={item.id}>
                  <div className="twm-jobs-list-style1 mb-5">
                    <div className="twm-media">
                      <GetProfileImage id={item?.id} type={"userAvatar"} />
                    </div>
                    <div className="twm-mid-content">
                      <h4>{`${item?.firstName} ${item?.lastName}`}</h4>
                      <div>
                        <StarRating rating={item?.applicantAverageRating} />
                        <span style={{ fontSize: 12 }}>
                          {(item?.applicantNumberOfReviews || 0) + " Reviews"}
                        </span>
                      </div>
                      <span className="twm-job-address">{item?.email}</span>
                    </div>

                    <div className="twm-right-content d-flex">
                      <div className="twm-jobs-category green">
                        {(item?.isPrivateEmployee && isSameInstitutionJob) ||
                        isAdminRole ? (
                          <a
                            className={`site-button ${
                              item?.isTrustedWorker &&
                              role_type?.includes("ROLE_INSTITUTION_ADMIN")
                                ? ""
                                : "button-sm"
                            }`}
                            role="button"
                            onClick={() => {
                              assignJobToApplicantConfirmation(item, "assign");
                            }}
                          >
                            Assign
                          </a>
                        ) : (
                          item?.isPrivateEmployee && (
                            <a
                              className={`site-button`}
                              role="button"
                              onClick={() => {
                                // applyTrustedCompanyJobToEmployee(
                                //   item?.applicantId,
                                //   item
                                // );
                                assignJobToApplicantConfirmation(item, "apply");
                              }}
                            >
                              {selectedEmployee === item?.applicantId ? (
                                <Spinner />
                              ) : (
                                "Apply"
                              )}
                            </a>
                          )
                        )}
                      </div>
                      {(isSameInstitutionJob || isAdminRole) && (
                        <div className="twm-jobs-category green">
                          <a
                            className={`site-button ${
                              jobDetailsInfo?.isTrustedWorkerOnly && !jobDetailsInfo?.isEmployeeOnly &&
                              role_type?.includes("ROLE_INSTITUTION_ADMIN")
                                ? ""
                                : "button-sm"
                            } m-l10`}
                            // className={`site-button button-sm m-l10`}
                            role="button"
                            onClick={() => {
                              assignJobToApplicantConfirmation(item, "invite");
                            }}
                          >
                            Invite
                          </a>
                        </div>
                      )}
                    </div>
                  </div>
                </li>
              ))
            ) : (
              "No results found."
            )
          ) : (
            <TableLoader />
          )}
        </ul>
      </div>
      <SectionPagination
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        totalPages={totalPages}
      />
      <AssignJobConfirmation
        selectedTrustedWorkerEmployee={selectedTrustedWorkerEmployee}
        fetchTrustedWorkerEmployeeList={fetchTrustedWorkerEmployeeList}
        buttonType={buttonType}
      />
    </>
  );
}

export default SectionTrustedWorkerEmployeeList;
